<div class="form-group">
  <div class="form-sub-group">
    <label [attr.for]="id">
      {{ label }}
      @if (required) {
        <span class="required">*</span>
      }
    </label>
    <input nbInput fullWidth
           [id]="id"
           [value]="value | date:'MM/dd/yyyy HH:mm'"
           (blur)="onTouched()"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [nbDatepicker]="dateTimePicker">
    <nb-date-timepicker [withSeconds]="withSeconds" (dateTimeChange)="onInputChange($event)" #dateTimePicker></nb-date-timepicker>
  </div>
  @if (showErrors && control) {
    @if (control.invalid && (control.touched || control.dirty)) {
      <div class="error-messages">
        @if (control.errors?.['required']) {
          <span class="error-message">{{ requiredMessage || ('common.mandatory' | translate) }}</span>
        }
      </div>
    }
  }
</div>
